import React from 'react'
import { useTranslation } from 'react-i18next'

interface KeyboardShortcutsModalProps {
    isOpen: boolean
    onClose: () => void
}

const KeyboardShortcutsModal: React.FC<KeyboardShortcutsModalProps> = ({ isOpen, onClose }) => {
    const { t } = useTranslation()

    if (!isOpen) return null

    return (
        <div className="modal is-active">
            <div className="modal-background" onClick={onClose}></div>
            <div className="modal-content float-in" style={{ maxWidth: '700px', margin: 'auto', padding: '2rem' }}>
                <div className="box" style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
                    <h2 className="title is-4 mb-4 fade-scale">{t('keyboardShortcuts')}</h2>
                    <div className="columns">
                        <div className="column">
                            <div className="content">
                                <h4 className="subtitle is-6 mb-2 nav-item-animate">{t('navigation')}</h4>
                                <ul className="shortcut-list">
                                    <li className="nav-item-animate">
                                        <kbd>Ctrl+Shift+1</kbd> {t('goToRecords')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Ctrl+Shift+2</kbd> {t('goToRoutes')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Ctrl+Shift+3</kbd> {t('goToMapFleet')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Ctrl+Shift+4</kbd> {t('goToReport')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Ctrl+Shift+5</kbd> {t('goToLiveConnect')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Ctrl+Shift+6</kbd> {t('goToAdmin')}
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="column">
                            <div className="content">
                                <h4 className="subtitle is-6 mb-2 nav-item-animate">{t('actions')}</h4>
                                <ul className="shortcut-list">
                                    <li className="nav-item-animate">
                                        <kbd>Shift+S</kbd> {t('openSearch')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Shift+D</kbd> {t('createDedicatedOrder')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Shift+O</kbd> {t('createSingleOrder')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Shift+I</kbd> {t('openBulkImport')}
                                    </li>
                                    <li className="nav-item-animate">
                                        <kbd>Shift+\</kbd> {t('toggleAIAssistant')}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <p className="has-text-grey is-size-7 mt-4 nav-item-animate">{t('checkBackLater')}</p>
                </div>
            </div>
            <button
                className="modal-close is-large"
                aria-label="close"
                onClick={onClose}
            ></button>
        </div>
    )
}

export default KeyboardShortcutsModal 